import {MouseEventHandler} from "react";

import Button from "@/components/button/Button.tsx";

interface CTASendRequestProps {
  handleClick: MouseEventHandler;
  disabled: boolean;
}

export const CTASendRequest = ({handleClick, disabled}: CTASendRequestProps) => (
  <div className="d-flex align-items-center h-100">
    <Button onClick={handleClick} disabled={disabled}>
      Send Request
    </Button>
  </div>
);
